<template>
  <div>
    <!-- <v-app-bar class="transparent elevation-0">
      <BtnLanguages class="ml-auto" />
    </v-app-bar> -->
    <v-container>
      <v-row
        :class="$vuetify.breakpoint.mobile ? 'mt-0' : 'mt-6'"
        justify="center"
      >
        <v-col cols="12" sm="8" md="4">
          <div class="text-center">
            <img
              class="cursor-pointer mr-1 mb-6"
              :style="{
                'max-width': $vuetify.breakpoint.smAndDown ? '100px' : '200px',
                'max-height': '130px',
              }"
              v-on:click="toRoute('home')"
              aspect-ratio="1.0"
              :src="
                `https://sga-assets.s3-sa-east-1.amazonaws.com/domains/${operator.operator_code}/img/logo.png`
              "
              :alt="operator.operator_code"
            />
          </div>

          <v-card
            class="transparent elevation-0 py-5 mx-auto"
            style="max-width: 600px"
          >
            <!-- <v-card-title class="pb-4 px-10 justify-center">
              <div class="font-weight-light">
                {{ $t("login") }}
                <span class="font-weight-bold text-uppercase accent-4">{{
                  operator.operator_code
                }}</span>
              </div>
            </v-card-title> -->
            <v-form ref="form">
              <v-card-text class="px-10">
                <v-switch
                  v-if="isCreditOnline"
                  v-model="isCollaborator"
                  :label="$t('loginAsCollaborator')"
                ></v-switch>
                <v-text-field
                  label="Login"
                  name="login"
                  prepend-icon="mdi-account"
                  type="text"
                  v-model="form.login"
                  solo-inverted
                  :rules="[(v) => !!v || $t('thisFieldIsRequired')]"
                  clearable
                  autofocus
                  tabindex="1"
                ></v-text-field>
                <v-text-field
                  id="password"
                  :label="$t('password')"
                  name="password"
                  prepend-icon="mdi-lock"
                  v-model="form.password"
                  solo-inverted
                  clearable
                  :type="show1 ? 'text' : 'password'"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show1 = !show1"
                  tabindex="2"
                  :rules="[(v) => !!v || $t('thisFieldIsRequired')]"
                ></v-text-field>
                <!-- Input abaixo deixa sem sugestão de senha -->
                <!-- <v-text-field
                  :class="[
                    !form.password || show1 ? 'show-password' : 'hide-password',
                  ]"
                  id="password"
                  :label="$t('password')"
                  name="password"
                  prepend-icon="mdi-lock"
                  v-model="form.password"
                  solo-inverted
                  clearable
                  type="text"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword"
                  tabindex="2"
                  :rules="[(v) => !!v || $t('thisFieldIsRequired')]"
                ></v-text-field> -->
              </v-card-text>
              <v-card-actions class="px-10">
                <v-spacer></v-spacer>
                <v-btn
                  :loading="loading"
                  type="submit"
                  color="info"
                  block
                  v-on:click.prevent="doLogin"
                  tabindex="3"
                  >{{ $t("loginButton") }}</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-form>
          </v-card>
          <BtnLanguages class="mt-4 px-10" />
        </v-col>
      </v-row>

      <ConfirmToken
        :dialog="dialogs.otp"
        :loadings="loadings"
        @closeDialog="dialogs.otp = false"
        @doLogin="doLogin"
      />

      <RegisterPhone
        :dialog="dialogs.phone"
        :loading="loadings.submitPhone"
        @closeDialog="dialogs.phone = false"
        @openDialog="dialogs.phone = true"
        @doLogin="doLogin"
      />

      <ChangePassword
        :dialog="dialogs.changePassword"
        :loading="loadings.changePassword"
        @closeDialog="dialogs.changePassword = false"
        @doLogin="doLogin"
      />
    </v-container>
  </div>
</template>
<script>
import BtnLanguages from "@/components/btn-languages/btn-languages";
import ConfirmToken from "./ConfirmToken.vue";
import RegisterPhone from "./RegisterPhone.vue";
import ChangePassword from "./passwordRegistration";

import Vue from "vue";
export default {
  name: "Login",
  components: {
    BtnLanguages,
    ConfirmToken,
    RegisterPhone,
    ChangePassword,
  },
  data: () => {
    return {
      show1: false,
      loading: false,
      form: {
        login: "",
        password: "",
      },
      level: "",
      isCollaborator: false,

      dialogs: {
        otp: false,
        phone: false,
        changePassword: false,
      },
      loadings: {
        resendOtp: false,
        submitOtp: false,
        submitPhone: false,
        changePassword: false,
      },

      mapLevelNumberToName: {
        3: "localManager",
        4: "regionalManager",
        6: "administrator",
        8: "collaborator",
      },
    };
  },
  mounted() {
    // adiciona uma class 'login' no html para
    // tratamento do background via css.
    document.documentElement.classList.add("login");

    const isCollaborator = JSON.parse(localStorage.getItem("isCollaborator"));
    this.isCollaborator = isCollaborator;
  },
  computed: {
    operator() {
      return {
        operator_code: this.$route.params.operator,
      };
    },
    isCreditOnline() {
      return this.$store.state.operator.credit === "2";
    },
  },

  watch: {
    isCollaborator(value) {
      localStorage.setItem("isCollaborator", value);
    },
  },

  methods: {
    // showPassword() {
    //   this.show1 = !this.show1;
    // },
    doLogin(data = null) {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;
      const login = Object.assign(this.form, this.operator);

      const type = data ? data.type : false;

      if (data) {
        this.loadings[type] = true;

        if (data.phone && data.phone.length === 11) {
          login.phone = data.phone;
        } else {
          delete login.phone;
        }

        if (data.token && data.token.length === 6) {
          login.token = data.token;
        } else {
          delete login.token;
        }

        if (data.newPassword) {
          login.password_new = data.newPassword;
        } else {
          delete login.password_new;
        }
      }

      const endpoint = this.isCollaborator
        ? "/colab/user/login"
        : "/auth/login";

      this.$axios
        .post(endpoint, this.$formdata(login))
        .then((resp) => {
          if (resp.status === 202) {
            const data = resp.data.dados;

            if (data && data.token_sent) {
              this.dialogs.phone = false;
              this.dialogs.otp = true;
              this.dialogs.changePassword = false;

              this.$store.commit("setFeedbackSnack", {
                msg: resp.data.messages,
                color: "success",
              });
            }

            if (data && data.renew_password) {
              this.dialogs.changePassword = true;

              this.$store.commit("setFeedbackSnack", {
                msg: resp.data.messages,
                color: "warning",
              });
            }
          }

          if (resp.status === 200) {
            this.handleLoginSuccess(resp);
            this.$router.go();
          }

          // Remover tempo de bloqueio do LocalStorage em caso de sucesso
          localStorage.removeItem("timeDeviceLocked");
        })
        .catch((e) => {
          if (
            (window.navigator.onLine && typeof e.response === "undefined") ||
            e.response.status === 429
          ) {
            this.$store.commit("setFeedbackSnack", {
              msg: this.$t("toManyTryLogin", {
                timeLeft: this.getTimeLeftDeviceLocked(),
              }),
              color: "warning",
            });
          } else if (e.response.status === 406) {
            if (e.response.data.dados.needs_to_register_phone) {
              this.dialogs.otp = false;
              this.dialogs.phone = true;
            }
          } else {
            this.$store.commit("setFeedbackSnack", {
              msg: e.response.data.messages.error,
              color: "warning",
            });
          }
        })
        .finally(() => {
          this.loading = false;

          if (type) {
            this.loadings[type] = false;
          }
        });
    },

    handleLoginSuccess(res) {
      const data = res.data;
      const { token_jwt, user_data, token_exp } = data;

      let permissions = [];

      if (this.isCollaborator) {
        permissions = data.permissions;
        user_data.permissions = permissions;
        user_data.nivel = 8;
      }

      const date = token_exp.replace(/-/g, "/");
      localStorage.setItem("tokenExpirationDate", JSON.stringify(date));

      user_data.isCollaborator = this.isCollaborator;

      this.level = this.mapLevelNumberToName[user_data.nivel];

      this.$localStorage.setItem("token", token_jwt);
      this.$localStorage.setItem("user_data", user_data);
      this.$localStorage.setItem("level", this.level);
      this.$localStorage.setItem("auth", "true");

      Vue.prototype.$axios.defaults.headers.common[
        "Application-Authorization"
      ] = token_jwt;

      document.documentElement.classList.remove("login");

      if (this.$route.query.redirect) {
        this.$router.push(this.$route.query.redirect);
      } else {
        this.$router.push({ name: this.level });
      }
    },

    getTimeLeftDeviceLocked() {
      const getTimeDeviceLocked = JSON.parse(
        localStorage.getItem("timeDeviceLocked")
      );
      const nowTime = new Date().getTime();
      const diffTime = Math.round((nowTime - getTimeDeviceLocked) / 60000);
      let timeLeft = `1 ${this.$t("hour")}`;

      // Se não tiver algum dado no localStorage ou tiver ultrapassado uma hora
      // será adicionado data atual formatada no localStorage
      if (!getTimeDeviceLocked || diffTime > 60) {
        localStorage.setItem("timeDeviceLocked", JSON.stringify(nowTime));
      } else if (diffTime > 0) {
        const minutesLeft = 60 - diffTime;
        timeLeft = `${minutesLeft} ${this.$tc("minutes", minutesLeft)}`;
      }

      return timeLeft;
    },
  },
};
</script>
<style lang="css">
.login::before {
  content: "";
  display: block;
  opacity: 0.2;
  pointer-events: none;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url(https://sga-assets.s3-sa-east-1.amazonaws.com/images/6615bgloginauthsga.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
